import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DocumentTypeApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'documentType'
  }

}